import { useMemo } from 'react';
import { Card, Table } from 'react-bootstrap';
//import { Appointment } from './types/appointment.js';
import { DraggableAppointment } from './DraggableAppointment.js';
import { DroppableCell } from './DroppableCell.tsx';
import {
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  isSameDay,
  isToday,
  format,
} from 'date-fns';
import { ptBR } from 'date-fns/locale';


const timeSlots = Array.from({ length: 12 }, (_, i) => `${(i + 8).toString().padStart(2, '0')}:00`);

export function WeekView({ currentDate, appointments, onDateClick }) {
  const weekDays = useMemo(() => {
    const weekStart = startOfWeek(currentDate);
    const weekEnd = endOfWeek(currentDate);
    console.log(weekEnd)
    return eachDayOfInterval({ start: weekStart, end: weekEnd });
  }, [currentDate]);

  const getAppointmentsForDayAndHour = (day, hour) => {
    return appointments.filter((apt) => {
      return isSameDay(apt.date, day) && apt.startTime.startsWith(hour.split(':')[0]);
    });
  };

  return (
    <Card className="shadow-sm animate-fade-in overflow-hidden">
      <div className='table-responsive'>
        <Table bordered className="mb-0">
          <thead className="bg-light">
            <tr>
              <th className="text-center py-3" style={{ width: '80px' }}></th>
              {weekDays.map((day) => {
                const isDayToday = isToday(day);
                return (
                  <th

                    key={day.toISOString()}
                    onClick={() => onDateClick?.(day)}
                    className={`text-center py-3 ${isDayToday ? 'calendar-today' : ''}`}
                    style={{ cursor: 'pointer' }}
                  >
                    <small className="text-uppercase text-muted d-block">
                      {format(day, 'EEE', { locale: ptBR })}
                    </small>
                    <span className={`fs-5 fw-semibold ${isDayToday ? 'text-primary' : ''}`}>
                      {format(day, 'd')}
                    </span>
                  </th>
                );
              })}
            </tr>
          </thead>

          <tbody>
            {timeSlots.map((time) => (
              <tr key={time}>
                <td className="time-label text-end pe-2 text-muted small align-middle" style={{ width: '80px' }}>
                  {time}
                </td>
                {weekDays.map((day) => {
                  const dayAppointments = getAppointmentsForDayAndHour(day, time);
                  return (
                    <td key={`${day.toISOString()}-${time}`} className="p-0" style={{ height: '80px' }}>
                      <DroppableCell
                        id={`week-${format(day, 'yyyy-MM-dd')}-${time}`}
                        date={day}
                        time={time}
                        className="h-100 p-1 calendar-cell"
                      >
                        {dayAppointments.map((apt) => (
                          <DraggableAppointment key={apt.id} appointment={apt} compact />
                        ))}
                      </DroppableCell>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Card>
  );
}
